import React from 'react';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from './ThemeContext';
import { FinderProvider } from './FinderContext';
import { ConfigProvider } from './ConfigContext';
import { StudentProvider } from './StudentContext';
import { MarksProvider } from './MarksContext';
import { ReportProvider } from './ReportContext';
import { ReportViewProvider } from './ReportViewContext';
import { StaffProvider } from './StaffContext';
import { PermissionProvider } from './PermissionContext';
import { FeesBalanceProvider } from './FeesBalanceContext';
import { ContactProvider } from './ContactContext';


const SuperStore = ({ children }) => {
    return (
        <AuthProvider>
            <ThemeProvider>
                <ConfigProvider>
                    <FinderProvider>
                        <StudentProvider>
                            <MarksProvider>
                                <ReportProvider>
                                    <ReportViewProvider>
                                        <StaffProvider>
                                            <PermissionProvider>
                                                <FeesBalanceProvider>
                                                    <ContactProvider>{children}</ContactProvider>
                                                </FeesBalanceProvider>
                                            </PermissionProvider>
                                        </StaffProvider>
                                    </ReportViewProvider>
                                </ReportProvider>
                            </MarksProvider>
                        </StudentProvider>
                    </FinderProvider>
                </ConfigProvider>
            </ThemeProvider>
        </AuthProvider>
        
    );
};

export default SuperStore;